

(function () {

    angular.module('tmx-app')
        .controller('companyEditCtrl', ['$scope', 'resolvedData', 'lookupService', '$state',
            'ToastService','CompanyService', 

            function CompanyEditCtrl($scope, resolvedData,  lookupService, $state,
                ToastService,CompanyService) {

                var companyVM=this;
        ///////////////////////////////INITIALIZATIONS//////////////////////////////////////////////////////////////
                $scope.dataLoading = false;
                companyVM.showError=false;
                companyVM.lookup = {};
                companyVM.date = new Date().toJSON();
                companyVM.showStatus = false;
                companyVM.readonly = false;
                companyVM.CompanyCodeReadonly=false;
                companyVM.companycodeStatus=false;
                companyVM.editLoaded = false;
                companyVM.isEdit = false;

                companyVM.StartDateInvalid = true;
                companyVM.EndDateInvalid = true;
                companyVM.minDate = companyVM.date;
                companyVM.maxDate = companyVM.date;
                companyVM.dirtyFormControls = [];
                companyVM.formInvalid = false;
                lookupService.getCompanyTypes().then(function (types){
                    companyVM.lookup.type = types;  
                });
                lookupService.getCompanyClassification().then(function (classes){
                    companyVM.lookup.classification = classes;  
                });
        //companyVM.LocationTreeService = LocationTreeService;
///////////////// SETTING READONLY BASED ON DATA.INFO FROM $STATE parameter passed in from parent state/////////////////

                companyVM.StateInfo = JSON.parse(localStorage.getItem("ViewState"));
                //first time view
                if($state.data.info == true || companyVM.StateInfo==true ){
                    companyVM.readonly = true;
                    companyVM.CompanyCodeReadonly=true;
                    companyVM.StartDateReadonly = true;
                    companyVM.EndDateReadonly = true;
                }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //EDIT
                if(angular.isDefined(resolvedData.Company.data)) {
             
                    companyVM.vm = resolvedData.Company.data;
                    companyVM.EndDateString = new Date(companyVM.vm.EffectiveEndDate);
                    companyVM.StartDateString = new Date(companyVM.vm.EffectiveStartDate);
                    companyVM.isEdit = true;
                    companyVM.CompanyCodeReadonly=true;
                    companyVM.editLoaded = true;
                    if(angular.isDefined(companyVM.vm.TmXCompanyContactPerson) && companyVM.vm.TmXCompanyContactPerson!=null){
                        if(companyVM.vm.TmXCompanyContactPerson.Entity_Reference_Id == 0){
                            companyVM.vm.TmXCompanyContactPerson.Entity_Reference_Id = companyVM.vm.CompanyId;
                        }
                    }


            //if(companyVM.vm.EffectiveStartDate<companyVM.date)
            //{
            //    companyVM.StartDateReadonly = true;
            //}
            //else
            //    companyVM.StartDateReadonly = false;
            //if($state.data.info!=true){
            //// companyVM.StartDateReadonly = false;
            //    companyVM.EndDateReadonly = false;
            //}
                }
                 //ADD
                else{
                    companyVM.vm = resolvedData.Company; 
                    companyVM.StartDateReadonly = false;
                    companyVM.EndDateReadonly = false;
                    companyVM.CompanyCodeReadonly=false;
                    companyVM.editLoaded = false;
                    companyVM.vm.EffectiveStartDate = companyVM.date;
                }


                if(companyVM.vm.EffectiveEndDate<companyVM.date)companyVM.vm.status = "inactive";
                else if(angular.isDefined(companyVM.vm.TmxUserDevice))companyVM.vm.status = "active";
        
                companyVM.status = [
                    {
                        HiddenValue: "active",
                        VisibleValue: "Active"
                    },
                    {
                        HiddenValue: "inactive",
                        VisibleValue: "Inactive"
                    }];


 ////////////////////////////// COMPANY CODE UNIQUENESS CHECK FUNCTION////////////////////////////////////////////////
                companyVM.checkCompanyCode=function(value){
            //if(!companyVM.editLoaded){
                    if(angular.isDefined(value)){
                        if(value.length < 3){return;}
                        CompanyService.checkCompanyCode(value).then(function(data){
                     
                            if(data.status.message=="Company Code Already Exists"){
                                companyVM.companycodeStatus=true;
                            }
                            else{
                                companyVM.companycodeStatus=false;
                            }
                        });
                    }

            //}
            // else{
            //    companyVM.editLoaded = false;
            //}

                };

////////////////////////////////////////////////FORM VALIDATION/////////////////////////////////////////////////////////
                companyVM.getFormErrors = function() {
                    if(angular.isDefined(companyVM.dialogForm)) {
                        if(companyVM.dialogForm.$invalid) {
                            return companyVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                }

                companyVM.errorChanged = function(newErrors,oldErrors) {
                    if(newErrors!=oldErrors) {
                        companyVM.dirtyFormControls = [];
        // angular.forEach(newErrors, function (field) {
        //   angular.forEach(field, function(errorField){
        //     companyVM.dirtyFormControls.push(errorField.$name);
        //   })
        // });
                        angular.forEach(companyVM.dialogForm, function(value, key) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                 (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                if(key=="PhoneNumber"){
                                    var name = value.$name;
                                    name = name.replace(/([A-Z])/g, ' $1').trim();
                                    value.$name=name;
                                }
                                companyVM.dirtyFormControls.push(value.$name);                        
                            }
                        });
                        companyVM.error_msg = "Required field(s): "
                        for (var i = 0; i < companyVM.dirtyFormControls.length; i++) {
                            if(i==companyVM.dirtyFormControls.length-1) {
                                companyVM.error_msg +=  companyVM.dirtyFormControls[i];
                            }
                            else
                                companyVM.error_msg +=  companyVM.dirtyFormControls[i] + ", ";
                        }
                    }
                }

                $scope.$watch(companyVM.getFormErrors,companyVM.errorChanged,true);

///////////////////////////////////////////   SAVE FORM ///////////////////////////////////////////////////////////////
                companyVM.save = function(action,form){
                    companyVM.formSubmitted = true;

                    if (companyVM.dialogForm.$invalid) {
                        companyVM.formInvalid = true;
                        angular.forEach(form, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                       (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                value.$setTouched();
                            }
                        });
          //companyVM.showError=true;
         // companyVM.error_msg = "Required field(s): "
         // for (var i = 0; i < companyVM.dirtyFormControls.length; i++) {
         //  if(i==companyVM.dirtyFormControls.length-1)
         //  {
         //   companyVM.error_msg +=  companyVM.dirtyFormControls[i];
         //  }
         //  else
         //    companyVM.error_msg +=  companyVM.dirtyFormControls[i] + ", ";
         // }
         // ToastService.showCustomToast("error",companyVM.error_msg);
                    } //if form is valid
                    else{
                        companyVM.formInvalid = false;
                        $scope.dataLoading = true;
                        companyVM.vm.EffectiveStartDate = companyVM.date;
                        companyVM.vm.EffectiveEndDate = new Date('2099-12-31').toJSON();
                        if(companyVM.vm.TmXCompanyContactPerson!=null) {
                            if(angular.isDefined(companyVM.vm.TmXCompanyContactPerson.ContactPersonName)) {
                                companyVM.vm.TmXCompanyContactPerson.EffectiveEndDate = companyVM.vm.EffectiveEndDate;
                                companyVM.vm.TmXCompanyContactPerson.EffectiveStartDate = companyVM.vm.EffectiveStartDate;
                            }
                        }
                
                        companyVM.sendData = angular.copy(companyVM.vm);
                        if(angular.isDefined(companyVM.vm.TmxAddress) && angular.isDefined(companyVM.vm.TmxAddress.TmXAddressGeography)) {
                            companyVM.sendData.TmxAddress.TmXAddressGeography = undefined;
                        }
                        companyVM.sendData.$saveOrUpdate().then(function(promise){
                            $scope.dataLoading = false;

                            if(angular.isDefined($state.data.grid.companyGrid)) $state.data.grid.companyGrid.dataSource.read();
                            if(angular.isDefined(promise)) {
                                if(promise.status>=400) {
                                    companyVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if(angular.isDefined(promise.data.ModelState)) {
                                        var models=Object.keys(promise.data.ModelState);
                                        models.forEach(function (key){displayMsg+=(promise.data.ModelState[key])})
                                    }
                                    else{
                                        displayMsg = promise.data.Message;
                                    }
                        // companyVM.error_msg = promise.statusText;
                                    ToastService.showCustomToast("error",displayMsg);
                                }
                                else {
                                    if(action=="save") {
                                        $state.searchClear = true;
                                        $state.go("^");


                                    }
                                    else if(action=="saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                            else
                                ToastService.showCustomToast("error","Some Error Occured");
                        });
            //setting form to pristine
             

                    }
                };//save function end
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                companyVM.cancel = function(){
                    companyVM.formSubmitted = false;
                    delete companyVM.dialogForm;
                    $state.searchClear = true;
          // .$invalid=false;
                    $state.go("^").then(function(){
                    },function(){
                    });
                };


            }]);
})();

